import React from 'react'
import PageTitle from './include/PageTitle'
import Seo from '../Components/Seo'

const TeamDetails = () => {
    return (
        <div>
            <Seo
                title="QTECH Team Member | Real Estate Services Saudi Arabia"
                titleAr="عضو فريق شركة تقنيات الجودة | خدمات عقارية في السعودية"
                description="Learn more about the QTECH team supporting real estate services in Saudi Arabia."
                descriptionAr="تعرف على عضو من فريق شركة تقنيات الجودة الذي يدعم الخدمات العقارية في السعودية والخبر."
                keywords="QTECH team member, real estate services Saudi Arabia"
                keywordsAr="فريق شركة تقنيات الجودة، خدمات عقارية في السعودية، خدمات عقارية في الخبر"
                path="/team-details/1"
                image="/img/team/4.jpg"
            />
            <PageTitle titleKey="pages.teamDetails.title" currentPageKey="pages.teamDetails.title" bgImage="/img/bg/14.jpg" />




            <div className="ltn__team-details-area mb-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="ltn__team-details-member-info text-center mb-40">
                                <div className="team-details-img">
                                    <img src="img/team/4.jpg" alt="Team Member Image" />
                                </div>
                                <h2>Rosalina D. William</h2>
                                <h6 className="text-uppercase ltn__secondary-color">
                                    Property Seller
                                </h6>
                                <div className="ltn__social-media-3">
                                    <ul>
                                        <li>
                                            <a href="#" title="Facebook">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" title="Twitter">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" title="Linkedin">
                                                <i className="fab fa-linkedin" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="ltn__team-details-member-info-details">
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur.
                                </p>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="ltn__team-details-member-about">
                                            <ul>
                                                <li>
                                                    <strong>Positions:</strong> Senior Property Seller
                                                </li>
                                                <li>
                                                    <strong>Experience:</strong> 10+ Years
                                                </li>
                                                <li>
                                                    <strong>Location:</strong> 13/A, NYC
                                                </li>
                                                <li>
                                                    <strong>Practice Area:</strong> Property Seller
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ltn__team-details-member-about">
                                            <ul>
                                                <li>
                                                    <strong>Email:</strong> example@example.com
                                                </li>
                                                <li>
                                                    <strong>Fax:</strong> +0123-456 789
                                                </li>
                                                <li>
                                                    <strong>Phone:</strong> +0123-456 789
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                    culpa qui officia deserunt mollit anim id est laborum. Sed ut
                                    perspiciatis unde omnis iste natus error sit voluptatem accusantium
                                    doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo
                                    inventore veritatis et quasi architecto beatae vitae dicta sunt
                                    explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur
                                    aut odit aut fugit, sed quia consequu ntur magni dolores eos qui
                                    ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui
                                    dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                                    quia non numquam eius modi tempora incidunt ut labore et dolore
                                    magnam aliquam quaerat voluptatem.
                                </p>
                                <div className="row ltn__custom-gutter mt-50 mb-20">
                                    <div className="col-xl-4 col-sm-6 col-12">
                                        <div className="ltn__feature-item ltn__feature-item-6 text-center">
                                            <div className="ltn__feature-icon">
                                                <span>
                                                    <i className="icon-tire" />
                                                </span>
                                            </div>
                                            <div className="ltn__feature-info">
                                                <h4>
                                                    <a href="service.html">Home Buying</a>
                                                </h4>
                                                <p>
                                                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                                                    sed do eiusmod te mp or
                                                </p>
                                                {/* <a class="ltn__service-btn" href="service.html">Read More</a> */}
                                                <a className="ltn__service-btn" href="service-details.html">
                                                    Read More <i className="flaticon-right-arrow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6 col-12">
                                        <div className="ltn__feature-item ltn__feature-item-6 text-center">
                                            <div className="ltn__feature-icon">
                                                <span>
                                                    <i className="icon-mechanic" />
                                                </span>
                                            </div>
                                            <div className="ltn__feature-info">
                                                <h4>
                                                    <a href="team.html">Home Selling</a>
                                                </h4>
                                                <p>
                                                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                                                    sed do eiusmod te mp or
                                                </p>
                                                {/* <a class="ltn__service-btn" href="service.html">Read More</a> */}
                                                <a className="ltn__service-btn" href="service-details.html">
                                                    Read More <i className="flaticon-right-arrow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6 col-12">
                                        <div className="ltn__feature-item ltn__feature-item-6 text-center active">
                                            <div className="ltn__feature-icon">
                                                <span>
                                                    <i className="icon-wheel-1" />
                                                </span>
                                            </div>
                                            <div className="ltn__feature-info">
                                                <h4>
                                                    <a href="service-details.html">Escrow Services</a>
                                                </h4>
                                                <p>
                                                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                                                    sed do eiusmod te mp or
                                                </p>
                                                {/* <a class="ltn__service-btn" href="service.html">Read More</a> */}
                                                <a className="ltn__service-btn" href="service-details.html">
                                                    Read More <i className="flaticon-right-arrow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                    culpa qui officia deserunt mollit anim id est laborum. Sed ut
                                    perspiciatis unde omnis iste natus error sit voluptatem accusantium
                                    doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo
                                    inventore veritatis et quasi architecto beatae vitae dicta sunt
                                    explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur
                                    aut odit aut fugit, sed quia consequu ntur magni dolores eos qui
                                    ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui
                                    dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                                    quia non numquam eius modi tempora incidunt ut labore et dolore
                                    magnam aliquam quaerat voluptatem.
                                </p>
                                <div className="ltn__form-box contact-form-box box-shadow white-bg mt-50">
                                    <h4 className="title-2">Contact for any Inquiry</h4>
                                    <form
                                        id="contact-form"
                                        action="https://tunatheme.com/tf/html/quarter-preview/quarter/mail.php"
                                        method="post"
                                    >
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-item input-item-name ltn__custom-icon">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        placeholder="Enter your name"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-item input-item-email ltn__custom-icon">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Enter email address"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-item">
                                                    <select className="nice-select" style={{ display: "none" }}>
                                                        <option>Select Service Type</option>
                                                        <option>Property Management </option>
                                                        <option>Mortgage Service </option>
                                                        <option>Consulting Service</option>
                                                        <option>Home Buying</option>
                                                        <option>Home Selling</option>
                                                        <option>Escrow Services</option>
                                                    </select>
                                                    <div className="nice-select" tabIndex={0}>
                                                        <span className="current">Select Service Type</span>
                                                        <ul className="list">
                                                            <li
                                                                data-value="Select Service Type"
                                                                className="option selected"
                                                            >
                                                                Select Service Type
                                                            </li>
                                                            <li data-value="Property Management" className="option">
                                                                Property Management{" "}
                                                            </li>
                                                            <li data-value="Mortgage Service" className="option">
                                                                Mortgage Service{" "}
                                                            </li>
                                                            <li data-value="Consulting Service" className="option">
                                                                Consulting Service
                                                            </li>
                                                            <li data-value="Home Buying" className="option">
                                                                Home Buying
                                                            </li>
                                                            <li data-value="Home Selling" className="option">
                                                                Home Selling
                                                            </li>
                                                            <li data-value="Escrow Services" className="option">
                                                                Escrow Services
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-item input-item-phone ltn__custom-icon">
                                                    <input
                                                        type="text"
                                                        name="phone"
                                                        placeholder="Enter phone number"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input-item input-item-textarea ltn__custom-icon">
                                            <textarea
                                                name="message"
                                                placeholder="Enter message"
                                                defaultValue={""}
                                            />
                                        </div>
                                        <p>
                                            <label className="input-info-save mb-0">
                                                <input type="checkbox" name="agree" /> Save my name, email,
                                                and website in this browser for the next time I comment.
                                            </label>
                                        </p>
                                        <div className="btn-wrapper mt-0">
                                            <button
                                                className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                                type="submit"
                                            >
                                                get an free service
                                            </button>
                                        </div>
                                        <p className="form-messege mb-0 mt-20" />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>











        </div>




    )
}

export default TeamDetails